import type { AssetAddress } from '../addresses/types.ts'
import type { LatLng } from './types.ts'

export type GeocodeResult = {
  address: AssetAddress
  coordinates: LatLng
}
